export default __webpack_public_path__ + "static/media/cushion-cover-only.924ba796.webp";